import type { ReactNode } from "react";
import { cn } from "@/lib/utils";

interface LabelProps {
  className?: string;
  children: ReactNode;
  required?: boolean;
  hint?: ReactNode;
}

export function Label({ className, children, required, hint }: LabelProps) {
  return (
    <label
      className={cn(
        "mb-2 flex items-center gap-1.5 text-[11px] font-semibold uppercase tracking-wider text-studio-muted",
        className
      )}
    >
      {children}
      {required && <span className="text-studio-accent">*</span>}
      {hint}
    </label>
  );
}

interface FieldProps {
  label?: ReactNode;
  required?: boolean;
  hint?: ReactNode;
  error?: string | null;
  children: ReactNode;
}

export function Field({ label, required, hint, error, children }: FieldProps) {
  return (
    <div>
      {label && (
        <Label required={required} hint={hint}>
          {label}
        </Label>
      )}
      {children}
      {error && <p className="mt-1.5 text-xs text-studio-danger">{error}</p>}
    </div>
  );
}
